import { AccessLevel } from "@/api/williams/users";
import { Associations } from "./Associations";
import { Certifications, Welders } from "../../welders";
import { ConfirmationDialog } from "@/components/dialogs";
import { Contractor } from "@/api/williams/contractors";
import { ContractorDetails } from "./ContractorDetails";
import { Expirations } from "../../welders/components/Expirations";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";
import { getFullPath, routes } from "../../routes";
import { IconButton } from "../../components";
import { IncompleteItems } from "../../search";
import { Metrics } from "./Metrics";
import { ScopesOfWork } from "../../scopeOfWork";
import { StandardTests } from "../../standardTests";
import { TestEvents } from "../../testEvents";
import { useDeleteContractor } from "../hooks";
import { useModalDialog } from "@/hooks";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../users/hooks";

export function Dashboard({ contractor }: { contractor: Contractor }) {
  const dialog = useModalDialog();
  const deleteContractor = useDeleteContractor();
  const permissions = usePermissions();
  const navigate = useNavigate();

  function handleEditContractor() {
    navigate(getFullPath(routes.contractor.edit(contractor.id)));
  }

  function handleDeleteContractor() {
    dialog.show(ConfirmationDialog, {
      caption: "Delete Contractor",
      message: "Are you sure you want to delete this contractor?",
      onAccept: () => {
        deleteContractor.mutate(contractor, {
          onSuccess: () => navigate(getFullPath(routes.contractor.list)),
        });
      },
    });
  }

  return (
    <>
      <div className="d-md-flex justify-content-between mb-2">
        <h3>Contractor</h3>
        {permissions.data && permissions.data.accessLevel !== AccessLevel.GeneralUser && (
          <div className="d-flex gap-2 my-auto">
            <IconButton icon={faPenToSquare} title="Edit" onClick={handleEditContractor} />
            {permissions.data.accessLevel >= AccessLevel.AIWeldingSME && (
              <IconButton icon={faTrashAlt} title="Delete" onClick={handleDeleteContractor} />
            )}
          </div>
        )}
      </div>

      <div className="card mb-3">
        <div className="card-header">Contractor Details</div>
        <div className="card-body" style={{ maxWidth: 1000 }}>
          <ContractorDetails contractor={contractor} />
        </div>
      </div>

      <ul className="mb-5">
        <li className="mb-3">
          <Metrics contractorId={contractor.id} />
        </li>
        <li className="mb-3">
          <Associations contractorId={contractor.id} />
        </li>
        <li className="mb-3">
          <IncompleteItems filters={{ contractorId: contractor.id }} />
        </li>
        <li className="mb-3">
          <ScopesOfWork filters={{ contractorId: contractor.id }} contractor={contractor} />
        </li>
        <li className="mb-3">
          <TestEvents filters={{ contractorId: contractor.id }} contractor={contractor} />
        </li>
        <li className="mb-3">
          <Welders filters={{ contractorId: contractor.id }} contractor={contractor} />
        </li>
        <li className="mb-3">
          <Certifications filters={{ contractorId: contractor.id }} />
        </li>
        <li className="mb-3">
          <StandardTests filters={{ contractorId: contractor.id }} contractor={contractor} />
        </li>
        <li className="mb-3">
          <Expirations filters={{ contractorId: contractor.id }} />
        </li>
      </ul>
    </>
  );
}
